import { ForwardedRef, HTMLAttributes, forwardRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { IoClose } from 'react-icons/io5';

import { TEST_IDS } from 'commons';

import * as S from './styles';

interface Props extends HTMLAttributes<HTMLDivElement> {
  handleClose: () => any;
  padding?: string;
  closable?: boolean;
}

/**
 * it works standalone without the <Modal/>
 * but you have to create a new state manager
 * to show and hide the ModalContent
 */
export const ModalContent = forwardRef(
  (props: Props, ref: ForwardedRef<HTMLButtonElement> | null) => {
    const {
      handleClose,
      children,
      padding = '25px 20px 20px',
      closable = true,
    } = props;
    const elPortal = document.createElement('div');

    document.body.appendChild(elPortal);

    useEffect(() => {
      return () => {
        document.body.removeChild(elPortal);
      };
    }, [elPortal]);

    const modalContent = (
      <S.Wrapper data-testid={TEST_IDS.MODAL_COMPONENT}>
        <S.Background onClick={handleClose} />

        <S.Content style={{ padding }}>
          {closable && (
            <S.Icon ref={ref} type="button" onClick={handleClose}>
              <IoClose />
            </S.Icon>
          )}

          {children}
        </S.Content>
      </S.Wrapper>
    );

    return createPortal(modalContent, elPortal);
  }
);

ModalContent.displayName = 'ModalContent';
